import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Building2, LogOut } from "lucide-react";
import { useAuth } from "@/context/Auth";

const INATTIVITA_MS = 30 * 60 * 1000;

const useNoIndex = () => {
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow, noarchive";
    document.head.appendChild(m);
    const prev = document.title;
    document.title = "Area riservata aziende";
    return () => {
      document.head.removeChild(m);
      document.title = prev;
    };
  }, []);
};

const useIdleLogout = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (!user) return undefined;
    let t;
    const reset = () => {
      clearTimeout(t);
      t = setTimeout(async () => {
        await logout();
        nav("/aziende/accedi?scaduta=1");
      }, INATTIVITA_MS);
    };
    const ev = ["mousemove", "keydown", "click", "touchstart", "scroll"];
    ev.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      clearTimeout(t);
      ev.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [user, logout, nav]);
};

export const AreaLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  useNoIndex();
  useIdleLogout();
  return (
    <div className="min-h-screen flex flex-col bg-[#F3EEF9]" data-testid="area-aziende">
      <header className="bg-[#2E2440] text-[#FAF7FD]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/aziende" className="flex items-center gap-3" data-testid="area-logo">
            <span className="w-9 h-9 rounded-lg bg-[#7E5BAF] grid place-items-center"><Building2 size={18} /></span>
            <span>
              <span className="font-display text-xl font-semibold block leading-none">Regalami</span>
              <span className="text-[10px] uppercase tracking-[0.25em] text-[#C8A2E8]">Area riservata aziende</span>
            </span>
          </Link>
          {user && user.ruolo === "operatore" && (
            <div className="flex items-center gap-4 text-sm">
              <span className="hidden sm:inline text-[#E3D9F0]" data-testid="area-utente">{user.nome} · {user.ruolo_azienda}</span>
              <button onClick={async () => { await logout(); nav("/aziende/accedi"); }} className="flex items-center gap-1 hover:text-[#C8A2E8]" data-testid="area-logout-btn"><LogOut size={16} />Esci</button>
            </div>
          )}
        </div>
      </header>
      <div className="flex-1">{children}</div>
      <footer className="text-xs text-[#786E65] text-center py-6">Area riservata. Sessione con scadenza dopo 30 minuti di inattività.</footer>
    </div>
  );
};
